<template>
    <div>
        <van-nav-bar
            title="我的车辆"
            left-text="返回"
            right-text="添加车辆"
            left-arrow
            @click-left="clickback"
            @click-right="$refs.addcar.add()"/>
        <van-list>
            <div
                v-for="itm in data"
                :key="itm.id"
                @click="readyPick(itm)">
                <CarItem
                    :area="itm.area_name"
                    :code="itm.code"
                    :carcategory="itm.carcategory_name"
                    :isdefault="itm.is_default"
                    @delItem="delItem(itm)"
                    @setItem="setItem(itm)"
                />
            </div>
        </van-list>
        <AddCar ref="addcar" @refresh="getData" />
    </div>
</template>

<script>
import { CarApi } from '@/api/car'
import { 
    NavBar, 
    Toast, 
    List,
    Popup,
} from 'vant'
import AddCar from '@/view/user/components/addcar'   
import CarItem from '@/view/user/components/caritem'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Toast.name]: Toast,
        [List.name]:List,
        [Popup.name]: Popup,
        CarItem,
        AddCar
    },
    data() {
        return {
            data: [],
            cmdShow: false,
            loading: false,
            doId: 0,
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/user`)
            }
        },
        getData() {
            var that = this
            that.loading = true
            that.axios.get(CarApi).then((ret) => {
                that.loading = false
                console.log(ret)
                if (ret.flag) {
                    that.data = ret.details
                } else {
                    Toast(ret.info)
                }
            }).catch(function (error) {
                Toast(error)
            })
        },
        delItem(itm) {
            this.doItem(itm,1)
        },
        setItem(itm) {
            this.doItem(itm,0)
        },
        doItem(item,action) {
            var putData = {
                carid: item.id,
                action: action
            }
            var that = this
            that.loading = true
            that.axios.put(CarApi, putData).then((ret) => {
                that.loading = false
                console.log(ret)
                if (ret.flag) {
                    this.getData()
                } else {
                    Toast(ret.info)
                }
            }).catch(function (error) {
                Toast(error)
            })
        }
    }
}
</script>

<style>

</style>